"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupOrderLinesByDate = void 0;
const dayjs = require("dayjs");
const advancedFormat = require("dayjs/plugin/advancedFormat");
dayjs.extend(advancedFormat);
const groupOrderLinesByDate = (order_lines) => {
    const grouped_lines = [];
    const regions = order_lines.map((line) => {
        return line.region_id;
    });
    const unique_regions = regions.filter((value, index, self) => self.indexOf(value) === index);
    order_lines.forEach((line) => {
        const date = line.start_date;
        const existing_group = grouped_lines.find((group) => group.date === date);
        if (existing_group) {
            existing_group.order_lines.push(line);
        }
        else {
            grouped_lines.push({
                date: date,
                date_friendly: dayjs(date).format("ddd, Do MMM YYYY"),
                order_lines: [line],
            });
        }
    });
    // order each order_lines by region_id then by order_weight
    grouped_lines.forEach((group) => {
        group.order_lines.sort((a, b) => {
            if (a.region_id === b.region_id) {
                return a.order_weight - b.order_weight;
            }
            else {
                return (unique_regions.indexOf(a.region_id) -
                    unique_regions.indexOf(b.region_id));
            }
        });
    });
    // loop through each grouped_lines and get the days diff between each item.date
    grouped_lines.forEach((group, idx) => {
        if (idx === 0) {
            group.days_diff = 0;
            group.has_gap = false;
            group.multi_day_gap = false;
        }
        else {
            const prev_group = grouped_lines[idx - 1];
            group.days_diff = dayjs(group.date).diff(prev_group.date, "day") - 1;
            group.has_gap = group.days_diff > 0;
            group.multi_day_gap = group.days_diff > 1;
        }
    });
    return grouped_lines.sort((a, b) => {
        return new Date(a.date).getTime() - new Date(b.date).getTime();
    });
};
exports.groupOrderLinesByDate = groupOrderLinesByDate;
